import {Button, Col, Form, FormGroup, Input, Label, Row} from "reactstrap";
import { ReactComponent as DownloadIcon } from '../../../assets/images/download.svg';
import { ReactComponent as ContentItemIcon } from '../../../assets/images/contentItem.svg';
import { ReactComponent as TemplateIcon } from '../../../assets/images/template.svg';
import { ReactComponent as MoveUpIcon } from '../../../assets/images/order-up.svg';
import { ReactComponent as MoveUpDown } from '../../../assets/images/order-down.svg';
import moment from "moment/moment";
import React, {useEffect, useState} from "react";
import {EContentService} from "../../../globals/services/enhancedContent.service";
import {ContentService} from "../../../globals/services/content.service";
import { useSelector} from "react-redux";

export const Folder = (props) => {

    const { item, action } = props;
    const { me } = useSelector((state) => state.auth);
    const eContentService = EContentService();
    const contentService = ContentService();

    const initialState = {
        _id: item ? item._id : null,
        title: item ? item.title : null,
        subtitle: item ? item.subtitle : null,
        status: item ? item.status : null,
        type: item ? item.type : 'SHIHR',
        permissions: item ? item.permissions : [],
        templates: item ? item.templates : [],
        contentItems: item ? item.contentItems : [],
        contentTypes: item ? item.contentTypes : [],
        description: item ? item.description : null,
        createdBy: item ? item.createdBy : me ? me._id : null,
        created: item ? item.created : moment().format('YYYY-MM-DD'),
        modifiedBy: me ? me._id : null,
        modified: moment().format('YYYY-MM-DD'),
    }

    const [value, setValue] = useState('');
    const [state, setState] = useState(initialState);
    const [contentItemList, setContentItemList] = useState([]);
    const [filteredContentItemList, setFilteredContentItemList] = useState([]);

    useEffect(() => {

        eContentService.getSHIHRContentItems().then((res) => {
            setContentItemList(res);
        });

    }, [value]);

    const handleForm = (prop) => {
        setState({
            ...state,
            ...prop
        });
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        if (state._id) {
            eContentService.updateFolder(state).then((res) => action());
        } else {
            eContentService.createFolder(state).then((res) => action());
        }
    }


    const handleSearch = (searchItem) => {
        if (searchItem && searchItem.length > 2) {
            let filtered = contentItemList.filter((item) => {
                return item.title.toLowerCase().includes(searchItem.toLowerCase());
            });
            setFilteredContentItemList(filtered);
        }
    }

    const calculateNextContentItemOrder = () => {
        let contentItems = state.contentItems ? state.contentItems : [];
        let arrOfOrderItems = contentItems.map((item) => item.order);
        let order;
        if (arrOfOrderItems.length === 0) {
            order = 1;
        } else {
            order = Math.max(...arrOfOrderItems) + 1;
        }
        return order;
    }

    const handleContentItemToFolder = (e, id) => {
        e.preventDefault();
        let contentItems = state.contentItems ? state.contentItems : [];
        let item = contentItemList.find((item) => item._id === id);
        console.log(item.description);
        let itemToFolder = {
            _id: item._id,
            title: item.title,
            description: item.description,
            order: calculateNextContentItemOrder(id),
            status: "active",
            type: item.type,
        }
        contentItems.push(itemToFolder);
        handleForm({ contentItems: contentItems });

    }

    const handleRemoveContentItem = (e, id) => {
        e.preventDefault();
        let contentItems = state.contentItems ? state.contentItems : [];
        let index = contentItems.indexOf(id);
        if (index > -1) {
            contentItems.splice(index, 1);
        }
        handleForm({ contentItems: contentItems });
    }

    const moveItemDown = (e, item) => {
        e.preventDefault();
        let contentItems = state.contentItems ? state.contentItems : [];
        [...contentItems].sort((a, b) => (a.order > b.order) ? 1 : -1)
            .map((item, index) => item.order = index+1);
        let targetIndex = parseInt(item.order)-1;
        let arrOfOrderItems = contentItems.map((item) => item.order);
        if (arrOfOrderItems.includes(targetIndex)) {
            let nextItemIndex = targetIndex+1;
            contentItems.map((x_item) => {
                if (x_item.order === targetIndex) {
                    x_item.order = nextItemIndex;
                }
                if (x_item._id === item._id) {
                    x_item.order = targetIndex;
                }
            });
            contentItems.sort((a, b) => (a.order > b.order) ? 1 : -1);
            handleForm({ contentItems: contentItems });
        } else {
            contentItems.map((x_item) => {
                if (x_item._id === item._id) {
                    x_item.order = targetIndex;
                }
            });
            contentItems.sort((a, b) => (a.order > b.order) ? 1 : -1);
            handleForm({ contentItems: contentItems });
        }

    }


    const moveItemUp = (e, item) => {
        e.preventDefault();
        let contentItems = state.contentItems ? state.contentItems : [];
        [...contentItems].sort((a, b) => (a.order > b.order) ? 1 : -1)
            .map((item, index) => item.order = index+1);
        let targetIndex = parseInt(item.order)+1;
        let arrOfOrderItems = contentItems.map((item) => item.order);
        if (arrOfOrderItems.includes(targetIndex)) {
            let nextItemIndex = targetIndex-1;
            contentItems.map((x_item) => {
                if (x_item.order === targetIndex) {
                    x_item.order = nextItemIndex;
                }
                if (x_item._id === item._id) {
                    x_item.order = targetIndex;
                }
            });
            contentItems.sort((a, b) => (a.order > b.order) ? 1 : -1);
            handleForm({ contentItems: contentItems });
        } else {
            contentItems.map((x_item) => {
                if (x_item._id === item._id) {
                    x_item.order = targetIndex;
                }
            });
            contentItems.sort((a, b) => (a.order > b.order) ? 1 : -1);
            handleForm({ contentItems: contentItems });
        }

    }

    const openContentItemPreview = (e, _id) => {
        e.stopPropagation();
        contentService.getContentItemById(_id).then((content)=>
        {
            if (content[0].type === 'file') {
                window.open(content[0].file, '_blank');
            } else if (content[0].type === 'external_link') {
                window.open(content[0].link, '_blank');
            }
        });

    };


    return (
        <div>
            {
                state._id ? <h2>Change Folder Properties</h2> : <h2>Create Folder Form</h2>
            }

            <Form>
                <Row className="mt-2">
                    <Col className="px-2 col-12 col-md-3">
                        <FormGroup>
                            <h5 className="mt-4"><Label htmlFor="_title">Title</Label></h5>
                            <Input
                                id="title"
                                name="title"
                                placeholder="with a placeholder"
                                type="text"
                                onChange={(e) => handleForm({ title: e.target.value })}
                                value={state.title ? state.title : ""}
                            />
                        </FormGroup>
                    </Col>
                    <Col className="px-2 col-12 col-md-3">
                        <FormGroup>
                            <h5 className="mt-4"> <Label htmlFor="_title">Sub Title</Label></h5>
                            <Input
                                id="subtitle"
                                name="subtitle"
                                placeholder="with a placeholder"
                                type="text"
                                onChange={(e) => handleForm({ subtitle: e.target.value })}
                                value={state.subtitle ? state.subtitle : ""}
                            />
                        </FormGroup>
                    </Col>
                </Row>
                <Row className="mt-2">
                    <Col className="px-2 col-12 col-md-7">
                        <FormGroup>
                            <h5 className="mt-4"> <Label htmlFor="_description">Description</Label></h5>
                            <Input
                                id="description"
                                name="description"
                                type="textarea"
                                onChange={(e) => handleForm({ description: e.target.value })}
                                value={state.description ? state.description : ""}
                            />
                        </FormGroup>
                    </Col>
                </Row>
                <Row className="mt-2">
                    <Col className="px-2 col-12 col-md-2">
                        <FormGroup className="mb-3 mt-3 mt-lg-0">
                            <h5 className="mt-4"> <Label htmlFor="_status">Status</Label></h5>
                            <select className="selectInput" id="folderStatus" value={state.status ? state.status : ""} onChange={(e) => handleForm({ status: e.target.value })}>
                                <option value=""></option>
                                <option value="Active">Active</option>
                                <option value="Suspended">Suspended</option>
                                <option value="Draft">Draft</option>
                            </select>
                        </FormGroup>
                    </Col>

                    <Col className="px-2 col-12 col-md-2">
                        <FormGroup className="mb-3 mt-3 mt-lg-0">
                            <h5 className="mt-4"> <Label htmlFor="_status">Location</Label></h5>
                            <select className="selectInput" id="folderPermissions" value={state.permissions ? state.permissions : ""} onChange={(e) => handleForm({ permissions: e.target.value })}>
                                <option value=""></option>
                                <option value="Faculty">חיי קהילת המכון</option>
                                <option value="Staff">נהלים וטפסים</option>
                                <option value="OpenFaculty">תיקייה פתוחה בחלק עליון של המסך</option></select>
                        </FormGroup>
                    </Col>

                </Row>

                <Row className="mt-2">
                    <Col className="px-2 col-md-4">
                        <FormGroup>
                            <h5 className="mt-4"> <Label htmlFor="_search">Search content items</Label></h5>
                            <Input
                                id="searchContentItems"
                                name="searchContentItems"
                                type="text"
                                onChange={(e) => handleSearch(e.target.value)}
                            />
                        </FormGroup>
                        {
                            filteredContentItemList && filteredContentItemList.length > 0 ? filteredContentItemList.map((item) => {
                                return (
                                    <div className="d-flex ContentItemRecord addContentItemRecord">
                                        <ContentItemIcon className="CIcon"/>
                                        <div className="">{item.title}</div>
                                        <div className="addItemToFolder" onClick={(e)=>handleContentItemToFolder(e, item._id)}>Add to folder</div>
                                    </div>
                                )
                            }, this) : null
                        }
                    </Col>
                    <Col className="px-2 col-md-7 ContentItemContainer">
                        <h5 className="mt-0"> <Label htmlFor="_status">Content items in folder</Label></h5>
                        {
                            state.contentItems && state.contentItems.length > 0 ? state.contentItems.map((item) => {
                                return (
                                    <div className="d-flex ContentItemRecord">
                                        <DownloadIcon className="ReorderIcon" onClick={(e)=>openContentItemPreview(e, item._id)} />
                                        <MoveUpIcon className="ReorderIcon" onClick={(e)=>moveItemDown(e, item)} />
                                        <MoveUpDown className="ReorderIcon" onClick={(e)=>moveItemUp(e, item)} />
                                        <div className="">{item.title}</div>
                                        <div className="removeItem ml-auto" onClick={(e)=>handleRemoveContentItem(e, item)}>X</div>

                                    </div>
                                )
                            }, this) : null
                        }
                    </Col>
                </Row>
                <Row className="mt-2">
                    <Col className="px-2 col-12 col-md-3">
                        <Button onClick={(e)=>handleSubmit(e)}>
                            Save
                        </Button>
                    </Col>
                </Row>


            </Form>
        </div>
    )
}